export { default } from './notes-stacked'
